/**
 * Extracts the `asks` array from an action payload, tolerating either the
 * canonical `{ asks: [...] }` shape or a legacy flat payload (treated as a
 * single-ask batch). Returns an empty array if nothing usable is present.
 */
export const extractAsks = (data: unknown): unknown[] => {
	if (data && typeof data === 'object' && !Array.isArray(data)) {
		const asks = (data as Record<string, unknown>).asks;
		if (Array.isArray(asks)) {
			return asks;
		}

		// Legacy fallback: the planner used to emit a flat single-ask payload.
		// Treat it as a 1-item batch so history replay still renders.
		return [data];
	}

	return [];
};
